document.addEventListener('DOMContentLoaded', function () {
    // ============= START : Price and review div wrapped in PDP JS =========================
    function wrapElements() {
        const productMetas = document.querySelectorAll('.product-single__meta');
        productMetas.forEach((meta) => {
            const priceBlock = meta.querySelector('.product-block.product-block--price');
            const reviewBadge = meta.querySelector('.jdgm-widget, .shopify-app-block .jdgm-widget');
            if ( priceBlock && reviewBadge && !meta.querySelector('.product-price-wrap')) {
                const wrapper = document.createElement('div');
                wrapper.classList.add('product-price-wrap');
                priceBlock.parentNode.insertBefore(wrapper, priceBlock);
                wrapper.appendChild(priceBlock);
                wrapper.appendChild(reviewBadge);
            }
        });
    }
    window.addEventListener('load', () => {
        setTimeout(wrapElements, 1000);
    });
    const observer = new MutationObserver(() => {
        wrapElements();
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // ============= END : Price and review div wrapped in PDP JS =========================

    // ==================== START : Modal Append on Body JS ================================
    document.querySelectorAll('.modal--quick-shop').forEach(function(modal) {
        document.body.appendChild(modal);
    });
    // ==================== END : Modal Append on Body JS ================================

    // ======================= START : Collection page  Price range filters js ========================
    document.querySelectorAll(".fm-price-wrap").forEach((wrap) => {
        const minRange = wrap.querySelector(".fm-range-min");
        const maxRange = wrap.querySelector(".fm-range-max");
        const minInput = wrap.querySelector(".fm-input-min");
        const maxInput = wrap.querySelector(".fm-input-max");
        const minText = wrap.querySelector(".fm-min-text");
        const maxText = wrap.querySelector(".fm-max-text");
        const rangeFill = wrap.querySelector(".fm-slider-range");
        function updateSlider() {
            let min = parseInt(minRange.value);
            let max = parseInt(maxRange.value);
            if (min > max) {
                min = max;
                minRange.value = min;
            }
            minInput.value = min;
            maxInput.value = max;
            minText.textContent = "$" + min;
            maxText.textContent = "$" + max;
            const minPercent = ((min - minRange.min) / (minRange.max - minRange.min)) * 100;
            const maxPercent = ((max - maxRange.min) / (maxRange.max - maxRange.min)) * 100;
            rangeFill.style.left = minPercent + "%";
            rangeFill.style.width = (maxPercent - minPercent) + "%";
        }
        minRange.addEventListener("input", updateSlider);
        maxRange.addEventListener("input", updateSlider);
        updateSlider();
    });
    // ======================= END : Collection page  Price range filters js ========================

    // ========================= START : Cart Drawer Closed JS ===============================
    document.querySelectorAll('#CartDrawer .drawer__header .drawer__close').forEach(function (element) {
        element.addEventListener('click', function () {
            document.body.classList.remove('rebuy-cart-visible');
        });
    });
    document.addEventListener('click', function (e) {
        const cartDrawer = document.querySelector('#CartDrawer');
        if (
            cartDrawer &&
            !cartDrawer.contains(e.target) &&
            document.body.classList.contains('rebuy-cart-visible')
        ) {
            document.body.classList.remove('rebuy-cart-visible');
        }
    });
    // ========================= END : Cart Drawer Closed JS ===============================

    // ========================== START : PDP TOp PArt Accordin JS =================================
    document.addEventListener('click', function(e) {
        var trigger = e.target.closest('.product-block--tab .collapsible-trigger');
        if (!trigger) return;
        // If the trigger was just closed, nothing else to do.
        if (!trigger.classList.contains('is-open')) return;
        var block  = trigger.closest('.product-block--tab');
        var scope  = block.closest('.modal--quick-shop, .product-section') || document.body;
        scope.querySelectorAll('.product-block--tab').forEach(function(other) {
            if (other === block) return;
            var otherTrigger = other.querySelector('.collapsible-trigger.is-open');
            if (!otherTrigger) return;
            var moduleId    = otherTrigger.getAttribute('aria-controls') || otherTrigger.dataset.controls;
            var otherContent = moduleId ? document.getElementById(moduleId) : null;
            otherTrigger.classList.remove('is-open');
            otherTrigger.setAttribute('aria-expanded', 'false');
            if (otherContent) otherContent.classList.remove('is-open');
        });
    });
    // ========================== END : PDP TOp PArt Accordin JS =================================

    // ====================== START : Wholesale page Button JS =======================
    const wholesalebtn = document.querySelector(".btn.wholesale");
    if (wholesalebtn){
        wholesalebtn.addEventListener("click", function (e) {
            const isDesktop = window.matchMedia("(min-width: 768px)").matches;
            if (isDesktop) {
                e.preventDefault();
                // this.setAttribute("href", "#wholesale-apply");
                const target = document.querySelector(".wholesale-apply-section");
                if (!target) return;
                const offset = 100;
                const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({ top: top, behavior: "smooth"});
            } else {
                this.setAttribute("href", "mailto:info@fewmadejewelry.com");
            }
        });
    }
    // ====================== END : Wholesale page Button JS =======================
    // =============== START : Mobile Quick View: register Modals + eager pre-fetch content on touch devices =====================
    (function () {
        'use strict';
        var modalsSetup   = {}; 
        var contentLoaded = {};
        var fetchInFlight = {}; 
        function registerModal(id) {
            if (modalsSetup[id]) return;
            if (!window.theme || !theme.Modals) return;
            var modalEl = document.getElementById('QuickShopModal-' + id);
            if (!modalEl) return;
            modalsSetup[id] = true;
            new theme.Modals('QuickShopModal-' + id, 'quick-modal-' + id);
        }
        function loadModalContent(handle, id, btn, callback) {
            if (contentLoaded[id]) { callback(); return; }
            if (fetchInFlight[id]) {
                var orig = fetchInFlight[id];
                fetchInFlight[id] = function() { orig(); callback(); };
                return;
            }
            var holder = document.getElementById('QuickShopHolder-' + handle);
            if (!holder) { callback(); return; }
            var base = window.theme && theme.routes ? theme.routes.home : '';
            var url = (base + '/products/' + handle + '?view=modal').replace('//', '/');
            fetchInFlight[id] = callback;
            fetch(url)
            .then(function(r) { return r.text(); })
            .then(function(text) {
                var tmp = document.createElement('div');
                tmp.innerHTML = text;
                var section = tmp.querySelector('.product-section[data-product-handle="' + handle + '"]');
                if (section && holder) {
                    holder.innerHTML = '';
                    holder.appendChild(section);
                    holder.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
                        img.removeAttribute('loading');
                    });
                    if (window.theme) {
                        var sectionEl = holder.querySelector('[data-section-type="product"]');
                        if (sectionEl && theme.Product) {
                            new theme.Product(sectionEl);
                        }
                        theme.collapsibles.init();
                        theme.videoModal();
                    }
                }
                contentLoaded[id] = true;
                registerModal(id);
                var resolvedBtn = btn || document.querySelector('.grid-product[data-product-id="' + id + '"] .quick-product__btn');
                if (resolvedBtn) resolvedBtn.classList.remove('quick-product__btn--not-ready');
                var cb = fetchInFlight[id];
                delete fetchInFlight[id];
                cb();
            })
            .catch(function() {
                var cb = fetchInFlight[id];
                delete fetchInFlight[id];
                if (cb) cb();
            });
        }
        function prefetchCard(card) {
            var id     = card.dataset.productId;
            var handle = card.dataset.productHandle;
            if (!id || !handle || contentLoaded[id] || fetchInFlight[id]) return;
            var btn = card.querySelector('.quick-product__btn');
            loadModalContent(handle, id, btn, function() {});
        }
        function patchDesktopPreload() {
            if (!window.theme || !theme.preloadProductModal) {
                return setTimeout(patchDesktopPreload, 100);
            }
            theme.preloadProductModal = function(handle, productId, btn) {
                if (contentLoaded[productId]) {
                    registerModal(productId);
                    if (btn) btn.classList.remove('quick-product__btn--not-ready');
                    return;
                }
                if (fetchInFlight[productId]) {
                    var prev = fetchInFlight[productId];
                    fetchInFlight[productId] = function() {
                        prev();
                        registerModal(productId);
                        if (btn) btn.classList.remove('quick-product__btn--not-ready');
                    };
                    return;
                }
                loadModalContent(handle, productId, btn, function() {});
            };
        }
        function newCardsIn(node) {
            if (node.nodeType !== 1) return [];
            if (node.matches && node.matches('.grid-product[data-product-id][data-product-handle]')) {
                return [node];
            }
            return node.querySelectorAll? Array.from(node.querySelectorAll('.grid-product[data-product-id][data-product-handle]')): [];
        }
        (function trySetup() {
            if (!window.theme || !theme.Modals) return setTimeout(trySetup, 100);
            var isTouch = theme.config && theme.config.isTouch;
            var cards   = document.querySelectorAll('.grid-product[data-product-id][data-product-handle]');
            if (isTouch) {
                [].forEach.call(cards, function(card) {
                    var id  = card.dataset.productId;
                    var btn = card.querySelector('.quick-product__btn');
                    if (id) registerModal(id);
                    if (btn) btn.classList.add('quick-product__btn--not-ready');
                });
                document.addEventListener('touchstart', function(e) {
                    var btn = e.target.closest('.quick-product__btn');
                    if (!btn) return;
                    var card = btn.closest('.grid-product');
                    if (!card) return;
                    var id = card.dataset.productId;
                    if (id) registerModal(id);
                    prefetchCard(card);
                }, { passive: true });
            } else {
                patchDesktopPreload();
            }
            document.addEventListener('click', function(e) {
                var btn = e.target.closest('.quick-product__btn');
                if (!btn || !btn.classList.contains('quick-product__btn--not-ready')) return;
                var card = btn.closest('.grid-product');
                if (!card) return;
                var id     = card.dataset.productId;
                var handle = card.dataset.productHandle;
                if (!id || !handle) return;
                e.stopPropagation();
                e.preventDefault();
                if (!modalsSetup[id]) registerModal(id);
                loadModalContent(handle, id, btn, function() {
                    var trigger = document.querySelector('.js-modal-open-quick-modal-' + id);
                    if (trigger) trigger.click();
                });
            }, true);
            var cardObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(m) {
                    m.addedNodes.forEach(function(node) {
                        newCardsIn(node).forEach(function(c) {
                            var id  = c.dataset.productId;
                            var btn = c.querySelector('.quick-product__btn');
                            if (id) registerModal(id);
                            if (isTouch && btn) btn.classList.add('quick-product__btn--not-ready');
                            prefetchCard(c);
                        });
                    });
                });
            });
            cardObserver.observe(document.body, { childList: true, subtree: true });
        })();
    }());
    // =============== END : Quick View: register Modals + on-demand content loading =====================

    // ====================  START:  Search page  load more JS ==========================
    const btn = document.getElementById("LoadMoreBtn");
    const searchGrid = document.getElementById("SearchGrid");
    const countEl = document.getElementById("ProductCount");
    if (!btn || !searchGrid) return;
    let pagination = document.getElementById("PaginationData");
    let nextUrl = pagination ? pagination.dataset.nextUrl : null;
    if (!nextUrl) {
      btn.style.display = "none";
      return;
    }
    function updateProductCount() {
      const currentGrid = searchGrid.querySelector(".grid");
      if (!currentGrid || !countEl) return;
      const totalProducts = searchGrid.querySelectorAll('[data-type="product"]').length;
      countEl.textContent = `${totalProducts} ITEMS`;
    }
    updateProductCount();
    btn.addEventListener("click", function () {
      if (!nextUrl) {
        btn.style.display = "none";
        return;
      }
      btn.disabled = true;
      btn.textContent = "Loading...";
      fetch(nextUrl)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const newItems = doc.querySelectorAll("#SearchGrid .grid__item");
          const currentGrid = searchGrid.querySelector(".grid");
          if (!newItems.length || !currentGrid) {
            btn.style.display = "none";
            return;
          }
          newItems.forEach(item => {
            currentGrid.appendChild(item);
          });
          updateProductCount();
          const newPagination = doc.querySelector("#PaginationData");
          nextUrl = newPagination?.dataset.nextUrl || null;
          if (!nextUrl) {
            btn.style.display = "none";
          }
          btn.disabled = false;
          btn.textContent = "Load More";
        })
        .catch(error => {
          console.error("Load more error:", error);
          btn.disabled = false;
          btn.textContent = "Load More";
        });
    });
    // ====================  END:  Search page  load more JS ==========================

});